import gsap from 'gsap'

export const parallaxSection = () => {
  if (window.innerWidth <= 650) return

  const els = document.querySelectorAll('[data-parallax-section]')

  document.fonts.ready.then(() => {
    els.forEach((el) => {
      gsap.to(el, {
        y: 500,
        ease: 'none',
        opacity: 0.6,
        scrollTrigger: {
          trigger: el,
          start: 'bottom bottom',
          end: 'bottom top',
          invalidateOnRefresh: true,
          scrub: 0
        }
      })
    })
  })
}

export default () => {}
